import { EvaluationModelDto, type EvaluationDto } from "../../../autogen/bff-api";
import { pickDefaultWinner } from "./pickDefaultWinner";

/**
 * Which bids the award step arrives pre-selected with.
 *
 * ADR-033 D6: shopping products is an explicit choice of supplier, so a basket pre-selects its
 * bids whichever evaluation model is in play — a private event can both score award criteria and
 * shop products, and the basket has to reach the award step either way. Without a basket, a price
 * ranking leaves the choice to the buyer while a scored competition suggests its rank-1 bid.
 */
export const seedWinnerIds = (evaluation: EvaluationDto, basketBidIds: readonly string[]): string[] => {
  const validIds = evaluation.bids.map((bid) => bid.bidId);
  const shopped = [...new Set([...(evaluation.selectedBidIds ?? []), ...basketBidIds])];
  const preSelected = shopped.filter((id) => id && validIds.includes(id));
  if (preSelected.length > 0) return preSelected;

  if (evaluation.model === EvaluationModelDto.Price && !evaluation.rankedByJury) return [];
  const fallback = pickDefaultWinner(evaluation.bids);
  return fallback ? [fallback] : [];
};
